import { Bugfender } from '@bugfender/sdk';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import ReactDOM from 'react-dom/client';

import { AppWithQueryClient } from '@client/app';
import { messages } from '@client/locales';
import { queryClientDefaults } from '@client/store/queryClient.store';
import { initI18n, userLocale } from '@client/utils/i18n.util';
import { logger } from '@client/utils/logger.util';
import { getEnv, isProd } from '@common/utils';

import 'antd/dist/reset.css';
import '@teamco/ischeduler-antd/dist/ischeduler-antd.css';

const env = import.meta.env;

if (isProd(env, logger)) {
  Bugfender.init({
    appKey: getEnv('VITE_BUGFENDER_API_KEY', { env, logger }) as string,
    overrideConsoleMethods: false,
    printToConsole: false,
    registerErrorHandler: true,
    logBrowserEvents: false,
    logUIEvents: false,
    // version: '',
    // build: '',
  }).then(() => {
    logger.info('Bugfender initialized');
  });
}

initI18n(userLocale(), messages);

const queryClient = new QueryClient({
  defaultOptions: queryClientDefaults,
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AppWithQueryClient queryClient={queryClient} />
    </QueryClientProvider>
  </React.StrictMode>,
);
